import { siteStore } from "src/js/stores/site/store";
import { useMemo } from "react";
import { useSelectedWorkspaceQuery } from "./useSelectedWorkspaceQuery";
import { useSnapshot } from "valtio";
import { useWorkspacesList } from "react-migration/domains/workspaces/hooks/useWorkspacesList";

export function useWorkspacesDropdownList() {
  const { selectedWorkspaceId } = useSnapshot(siteStore);
  const { list, ...listQueryState } = useWorkspacesList();
  const { selectedWorkspace, ...selectedWorkspaceQueryState } = useSelectedWorkspaceQuery();
  const error = listQueryState.error || selectedWorkspaceQueryState.error;
  const loading = listQueryState.loading || selectedWorkspaceQueryState.loading;

  const listSansSelectedWorkspace = useMemo(
    () => list.filter((workspace) => workspace.id !== selectedWorkspaceId),
    [list, selectedWorkspaceId]
  );

  return {
    selected: selectedWorkspace,
    list: listSansSelectedWorkspace,
    error,
    loading,
  } as const;
}
